import NextableProvider from 'reservations/account/providers/NextableProvider';
import WaitlistOrBookingScreen from 'reservations/availabilities/components/WaitlistOrBookingScreen';
import PageLoadSpinner from 'reservations/base/components/PageLoadSpinner';
import useIsLoading from 'reservations/base/hooks/useIsLoading';
import { useQueryParams } from 'reservations/base/hooks/useQueryParams';

const LocationBySlug = () => {
  const { slug } = useQueryParams();
  const isPageLoading = useIsLoading();

  if (isPageLoading) {
    return (
      <PageLoadSpinner isLoading message="Finding first available date..." />
    );
  }

  return (
    <NextableProvider slug={slug}>
      <WaitlistOrBookingScreen slug={slug} />
    </NextableProvider>
  );
};

export default LocationBySlug;
